import React, { useEffect, useState, Fragment } from 'react';
import { Pagination, PageHeader, paginate } from '../../../Common';
import { TableContent } from '../../Common/Table/tableContent';
import { Fields, validateProperty, validate, Card } from "../../Common";
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import services from '../service';
import { search, SearchFeild } from '../../Common';
import MenuItem from '@material-ui/core/MenuItem';
import $ from 'jquery';
import { EmployeeBiometricSchemaObject } from '../EmployeeSchema';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import divisionService from '../../Devision/services'
import Joi, { func } from '@hapi/joi'
import { TextField } from '@material-ui/core';
import FileBase64 from 'react-file-base64';
import FormHelperText from '@material-ui/core/FormHelperText';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';
import { Button } from '@material-ui/core';
import { CommonEncryptParam } from '../../../../utils/CommonParams';

const screenCode = 'EMPLOYEE'

export function Listing(props) {
    const [employees, setEmployees] = useState([]);
    const [employeeSearchData, setEmployeeSearchData] = useState({
        groupID: 0,
        operationEntityID: 0,
        registrationNumber: '',
        NIC: ''

    });
    const [operationEntities, setOperationEntities] = useState([]);
    const [groups, setGroups] = useState();
    const [isTableHide, setIsTableHide] = useState(true);
    const contentRowNames = ["employeeCode", "fullName","cardNumber"]
    const [files, setFiles] = useState({});
    const [productImage, setProductImage] = useState({});
    const [errors, setErrors] = useState({});
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const schema = Joi.object(EmployeeBiometricSchemaObject).options({ allowUnknown: true });
    const screenData = "empScreen";

    useEffect(() => {
        trackPromise(
            getOperationEntities()
        )
    }, [employeeSearchData.groupID]);

    useEffect(() => {
        trackPromise(
            handleSearch()
        )
    }, [employeeSearchData.operationEntityID]);

    useEffect(() => {
        trackPromise(
            getPermissions()
        )
    }, []);

    async function getPermissions() {

        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWEMPLOYEE');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        var isAddEditEnabled = permissions.find(p => p.permissionCode == 'ADDEDITEMPLOYEE');
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isAddEditEnabled: isAddEditEnabled !== undefined,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setEmployeeSearchData({
            ...employeeSearchData,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });

        getAllGroups();
    }

    async function getOperationEntities() {
        const operationEntity = await services.GetAllOperationEntityByGroupID(employeeSearchData.groupID);
        setOperationEntities(operationEntity);
    }

    async function getAllGroups() {
        const result = await services.getGroups()
        setGroups(result);
    }

    function destroyDataTable() {
        $('#example').DataTable().destroy();
    }

    function createDataTable() {
        $('#example').DataTable();
    }

    function handleEmployeeBioClick(employee) {
        props.history.push({
            pathname: 'employee/employeeBiometricAddEdit/' + CommonEncryptParam(employee[0].employeeID.toString()),
            data: employee,
            edit: true
        });
    }

    function handleRsmEmployeeCardClick(employee) {
        props.history.push({
            pathname: 'rsmemployee/addEdit/'+ CommonEncryptParam(employee[0].employeeID.toString()),
            data: employee,
            edit: true,
            screen: screenData
        });
    }

    function handleEmployeeCardClick(employee) {
        props.history.push({
            pathname: 'employee/employeeCardAddEdit/'+ CommonEncryptParam(employee[0].employeeID.toString()),
            data: employee,
            edit: true,
            screen: screenData
        });
    }

    function generateDropDownMenu(data) {

        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items;
    }

    async function handleSearch(e) {
       
        if (e !== undefined) {
            const errorMessages = validate(schema, employeeSearchData);
            errorMessages !== null ? setErrors(errorMessages) : setErrors({});
            if (errorMessages) return;
        }

        const response = await services.GetEmployeeDetails(employeeSearchData);
        var resGrouped = groupByID(response);
        let keys = Object.keys(resGrouped);
        let arrayCollection = [];

        keys.forEach(x => {
            var res = pivotResultData(resGrouped[x]);
            arrayCollection.push(res);
        });

        setIsTableHide(false);
        destroyDataTable();
        setEmployees(arrayCollection);
        createDataTable();
    }

    function handleChange(e) {
        const target = e.target
        const value = (target.name === 'isActive' || target.name === 'isErpEnabled') ? target.checked : target.value

        const error = { ...errors }
        const errorMessage = validateProperty(target, EmployeeBiometricSchemaObject)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setEmployeeSearchData({
            ...employeeSearchData,
            [e.target.name]: value
        })

        setErrors(error)
    }

    
    function groupByID(objectArray) {
        return objectArray.reduce(function (acc, obj) {
            let key = obj['employeeID']
            if (!acc[key]) {
                acc[key] = []
            }
            acc[key].push(obj)
            return acc
        }, {})
    }

    function pivotResultData(data) {
        var result = [];
        data.forEach(function (e) {
            var a = e.employeeID;

            if (!this[a]) {

                this[a] = {
                    employeeID: e.employeeID,
                    employeeCode: e.employeeCode,
                    fullName: e.fullName,
                    cardNumber : e.cardNumber
                }
                result.push(this[a]);
            }
            if (e.accountTypeID === 1)
                this[a]["hasGeneral"] = true;
            if (e.accountTypeID === 2)
                this[a]["hasRSM"] = true;

        }, {});
        return result;
    }

    function clearState() {
        var token = tokenService.getUserDetailsFromToken();
        setEmployeeSearchData({
            ...employeeSearchData,
            groupID: !permissionList.isGroupFilterEnabled ? '0' : token.groupID,
            operationEntityID: !permissionList.isOperationEntityFilterEnabled ? '0' : token.operationEntityID,
            registrationNumber: '',
            NIC: '',
        });
        destroyDataTable();
        setEmployees([]);
        setIsTableHide(true);
    }

    function onCancelClick() {
        setErrors({});
        clearState();
    }
    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (
            <td key={index}>{da[0][row] + " "}</td>
           )
        )
    });

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <PageHeader
                                    title="Employee"
                                    isButtonEnable={permissionList.isAddEditEnabled}
                                    buttonText="Add Employee details"
                                    path="employee/employeeCardAddEdit" />
                            </div>
                            <hr />
                            <form>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            name="groupID"
                                            value={employeeSearchData.groupID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="operationEntityID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            name="operationEntityID"
                                            value={employeeSearchData.operationEntityID}
                                            onChange={(e) => handleChange(e)}>

                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(operationEntities)}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-md">
                                        <TextField fullWidth label="Registration Number"
                                            name="registrationNumber"
                                            id="registrationNumber"
                                            value={employeeSearchData.registrationNumber}
                                            type="text"
                                            onChange={(e) => handleChange(e)} />
                                    </div>
                                    <div className="col-md">
                                        <TextField fullWidth label="NIC"
                                            name="NIC"
                                            id="NIC"
                                            value={employeeSearchData.NIC}
                                            type="text"
                                            onChange={(e) => handleChange(e)} />
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, employeeSearchData)}
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={(e) =>trackPromise(handleSearch(e))}
                                        value="Search"
                                    />
                                    <input
                                        type="button"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </form>
                            <div className="table-responsive row-top-gap" >
                                <table id="example" className="display dataTable no-footer" hidden={isTableHide}>
                                    <thead>
                                        <tr>
                                            <th>Employee Code</th>
                                            <th>Employee Name</th>
                                            <th>Card Number</th>
                                            {permissionList.isAddEditEnabled ? <th>Actions</th> : null}
                                        </tr>
                                    </thead>
                                    <tbody>
                                {employees.map((data, i) => {
                                    return (
                                        <tr key={i}>
                                            {content(data)}
                                            <td>
                                                <div class="btn-group">
                                                    {data[0].hasGeneral ? <Button onClick={() => handleEmployeeCardClick(data)} style={{ cursor: "pointer" }}><i class="far fa-edit"></i></Button> : null}
                                                    <Button onClick={() => handleEmployeeBioClick(data)} style={{ cursor: "pointer" }}> <i class="fas fa-tasks"></i></Button>
                                                    {data[0].hasRSM ? <Button onClick={() => handleRsmEmployeeCardClick(data)} style={{ cursor: "pointer" }}> <i class="far fa-credit-card"></i></Button> : null}
                                                </div>
                                            </td> 
                                        </tr>
                                    );
                                })}
                            </tbody>
                                </table>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )


}